import { Pipe } from '@angular/core';
var IsLessEqualThanPipe = (function () {
    function IsLessEqualThanPipe() {
    }
    IsLessEqualThanPipe.prototype.transform = function (input, other) {
        return input <= other;
    };
    IsLessEqualThanPipe.decorators = [
        { type: Pipe, args: [{ name: 'isLessEqualThan' },] },
    ];
    /** @nocollapse */
    IsLessEqualThanPipe.ctorParameters = function () { return []; };
    return IsLessEqualThanPipe;
}());
export { IsLessEqualThanPipe };
//# sourceMappingURL=is-less-equal-than.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-less-equal-than.js
// module id = 247
// module chunks = 4